import { CasCRUDTable, CasRenderBoolTrueFalse } from 'src/compass/shared/components';
import AgenciesForm from './AgenciesForm';

export default function AgenciesTab() {
  return (
    <CasCRUDTable
      entity="Sce/Claims/InsAgency"
      entityTitle="Agency"
      columns={[
        { field: 'name', showEditOnclick: true },
        { field: 'agencyNbr', label: 'Agency#' },
        { field: 'claimsSharepointSite', label: 'Sharepoint Site' },
        { field: 'claimsSharepointRoot', label: 'Sharepoint Root' },
        { field: 'isActive', label: 'Active', render: CasRenderBoolTrueFalse },
      ]}
      editForm={AgenciesForm}
      includeExport={false}
    />
  );
}
